module.exports = __webpack_public_path__ + "img/mem_coupon_font4.d52b4d3f.jpg";